export default __webpack_public_path__ + "static/illo-track-87af176a808416481abb56aed93df050.svg";